const ru = {
  placeholderText: "Введите",
  closeContentText: "Завершить текущий диалог?",
  cancelText: "Отмена",
  okText: "ОК",
  loadingAnswerQuestions:
    "Отвечаю на предыдущий вопрос. Подождите перед отправкой.",
  networkAnomalyText: "Сетевой сбой. Повторите попытку позже.",
  errorText: "Ошибка сервера",
  messageTooShort: "Требуется ввести не менее двух символов.",
  messageTooLong: "Не более 200 символов.",
  systemErrorText: "Системная ошибка. Пожалуйста, повторите попытку позже.​​​",
  fileSizeExceeded: "Один файл не должен превышать {maxSize}MB.",
  abnormalDisconnectionText: "Сбой соединения. Переподключение...",
  evaluationText: "Ваша оценка помогает нам стать лучше!",
  emailLabel: "Адрес электронной почты​",
  emailPlaceholder: "Введите адрес электронной почты",
  emailErrorText: "Неверный формат электронной почты.",
  productLabel: "Продукт",
  productPlaceholder: "Выберите продукт",
  problemLabel: "Описание проблемы",
  problemPlaceholder: "Подробно опишите вашу проблему",
  submitText: "Отправить",
  submitField: "Отправка не выполнена. Повторите попытку позже.",
  thankText:
    "Спасибо за ваше содействие! Мы свяжемся с вами в ближайшее время! Пожалуйста, следите за почтой или {link}, чтобы увидеть ответ!",
  clickHere: "нажмите здесь​​",
  thankEvaluation: "​​Спасибо за вашу оценку!",
  codeLabel: "Код подтверждения",
  codePlaceholder: "Пожалуйста, введите код подтверждения",
  submittedSuccessfully: "Успешно отправлено",
  supportContact: "Контакт поддержки",
  stillCancel: "Всё равно отменить​",
  useDiscount: "Использовать скидку",
  pauseDuration: "Продолжительность паузы",
  uploadAttachment: "Загрузить вложение",
};
export default ru;
